import { VolumeUnits } from 'pando-constants';
import VolumeFormulaConvertor from '@common/helpers/volume-formula-converter';
const volumeConvertor = new VolumeFormulaConvertor();
function convertCftForDisplay(cftValue, isVolumeInCBM) {
  if (!cftValue) return 0;
  return isVolumeInCBM ? volumeConvertor.revertToClient(VolumeUnits.CBM, cftValue) : cftValue;
}
const getters = {
  isOptimaLoading: state => state.isOptimaLoading,
  isOptimaUpdating: state => state.isOptimaUpdating,
  isOptimaOrderLoading: state => state.isOptimaOrderLoading,
  all: state => state.all,
  totals: state => state.totals,
  orderDetails: state => state.orderDetails,
  compareList: state => state.compareList,
  editOrderIds: state => state.editOrderIds,
  materials: state => state.materials,
  consignees: state => state.consignees,
  default_settings: state => state.settings,
  defaultDepot: state => state.defaultDepot,
  xlsMaterials: state => state.xls_materials,
  vehicles: state => state.vehicles,
  not_combines: state => state.not_combines,
  isLoading: state => state.isLoading,
  optimaAutoRun: state => state.optimaAutoRun,
  selectedIndentMap: state => state.selectedIndentMap,
  indentIdWiseData: state => state.indentIdWiseData,
  indentBucket: state => state.indentBucket,
  configurations: state => state.data && state.data.configurations,
  preferredVolumeUnit: (state, getters, rootState, rootGetters) => {
  const config = rootGetters['app/configurations'];
  return (config && config.preferred_volume_unit) || VolumeUnits.CFT;
  },
  isVolumeInCBM: (state, getters) => {
  return getters.preferredVolumeUnit.toUpperCase() === VolumeUnits.CBM;
  },
  optimaRejectionsListData: state => state.optimaRejectionsListData,
  optimaAutoIndent: state => state.optimaAutoIndent,
  optimaCurrentJobId: state => state.optimaCurrentJobId,
  optimaCurrentPage: state => state.optimaCurrentPage,
  deliveryPicklist: state => state.deliveryPicklist,
  selectedPicklistMap: state => state.selectedPicklistMap,
  picklistIdsMap: state => state.picklistIdsMap,
  selectAllPicklistConsignees: state => state.selectAllPicklistConsignees,
  deliveryIndentsPickList: state => state.deliveryIndentsPickList,
  showIndentTopupDrawer: state => state.showIndentTopupDrawer,
  splitObject: state => state.splitObject,
  combineObject: state => state.combineObject,
  splitOrderSelectedIndex: state => state.splitOrderSelectedIndex,
  combineOrderSelectedIndex: state => state.combineOrderSelectedIndex,
  returnContracts: state => state.returnContracts,
  combineAndSplitBtnDisable: state => state.combineAndSplitBtnDisable,
  contractCollection: state => state.contractCollection,
  selectedDeliveryNumber: state => state.selectedDeliveryNumber,
  selectedItemsMetrics: (state, getters) => {
    const result = {
      totalQuantity: 0,
      totalWeight: 0,
      totalVolume: 0,
      totalWeightUnit: 'KG',
      totalVolumeUnit: getters.isVolumeInCBM ? 'CBM' : 'CFT',
      totalQuantityUnit: 'PCS',
      hasSelection: false,
    };

    // Aggregate mode: only when select-all is explicitly active AND totals are loaded
    if (state.selectAllPicklistConsignees && state.picklistAggregateTotals) {
      const t = state.picklistAggregateTotals;
      return {
        ...result,
        totalWeight: Number(Number(t.total_weight || 0).toFixed(3)),
        totalVolume: Number(Number(convertCftForDisplay(t.total_volume || 0, getters.isVolumeInCBM)).toFixed(3)),
        totalQuantity: Number(Number(t.total_quantity || 0).toFixed(3)),
        hasSelection: true,
      };
    }

    if (state.selectedDeliveryDetails && Object.keys(state.selectedDeliveryDetails).length) {
      Object.entries(state.selectedDeliveryDetails).forEach(([key, arr]) => {
       (arr || []).forEach((del, idx) => {
         const qty = Number(del.totals.quantity && del.totals.quantity.total ? del.totals.quantity.total.toFixed(3) : 0);
         const wt = Number(del.totals.weight && del.totals.weight.total ? del.totals.weight.total.toFixed(3) : 0);
         const volSource = del.totals.volume_for_display || del.totals.volume;
         let vol = 0;
         if (volSource && volSource.total) {
           const unit = (volSource.unit || '').toUpperCase();
           const preferred = getters.isVolumeInCBM ? VolumeUnits.CBM : VolumeUnits.CFT;
           vol = (unit === preferred || unit === '')
             ? Number(Number(volSource.total).toFixed(3))
             : Number(convertCftForDisplay(volSource.total, getters.isVolumeInCBM).toFixed(3));
          }
         result.totalQuantity += qty;
         result.totalWeight += wt;
         result.totalVolume += vol;
         result.hasSelection = true;
       });
     });
    }
    if (!state.selectedDeliveryNumber || Object.keys(state.selectedDeliveryNumber).length === 0) {
        return result;
      }
    if (!state.selectedPicklistIds || state.selectedPicklistIds.length === 0) {
      return result;
    }
    Object.entries(state.selectedDeliveryNumber).forEach(([s_no, materialIds]) => {
      if (!materialIds || materialIds.length === 0) return;

      const rawPicklist = (state.deliveryPicklist || []).find(p => {
        const k = String(p.fixed_s_no || p.s_no || (p.consignee && p.consignee.ref_id) || '');
        return k === s_no;
      });
      const picklist = state.selectedPicklistData[s_no];

      if (!rawPicklist && !picklist) return;

      const hasDeliveryDetailsForThisSno = state.selectedDeliveryDetails &&
                                          state.selectedDeliveryDetails[s_no] &&
                                          state.selectedDeliveryDetails[s_no].length > 0;
      if (hasDeliveryDetailsForThisSno) return;

      const rawVol = rawPicklist ? Number(rawPicklist.volume || 0) : Number(picklist.volume || picklist.vol || picklist.total_volume || 0);
      const rawWt = rawPicklist ? Number(rawPicklist.weight || 0) : Number(picklist.weight || picklist.wt || picklist.total_weight || 0);
      const rawQty = rawPicklist ? Number(rawPicklist.quantity || 0) : Number(picklist.quantity || picklist.qty || 0);
      const vol = rawPicklist ? convertCftForDisplay(rawVol, getters.isVolumeInCBM) : rawVol;
      result.totalQuantity += rawQty;
      result.totalWeight += rawWt;
      result.totalVolume += vol;
      result.hasSelection = true;
    });
    return result;
  },

  selectedPickListCount: state => state.selectedPickListIds.length,
  selectedIndentMetrics: (state, getters) => {
    const result = {
      totalQuantity: 0,
      totalWeight: 0,
      totalVolume: 0,
      totalWeightUnit: 'KG',
      totalVolumeUnit: getters.isVolumeInCBM ? 'CBM' : 'CFT',
      totalQuantityUnit: 'PCS',
      hasSelection: false,
    };
    if (state.selectAll && state.indentAggregateTotals) {
      const t = state.indentAggregateTotals;
      return {
        ...result,
        totalWeight: Number(Number(t.total_weight || 0).toFixed(3)),
        totalVolume: Number(Number(convertCftForDisplay(t.total_volume || 0, getters.isVolumeInCBM)).toFixed(3)),
        totalQuantity: Number(Number(t.total_quantity || 0).toFixed(3)),
        hasSelection: true,
      };
    }
    if (!state.selectedIndentIds || state.selectedIndentIds.length === 0) {
      return result;
    }
    state.selectedIndentIds.forEach(indentId => {
      const indentData = state.selectedIndentData[indentId];
      if (indentData) {
        result.totalQuantity += Number(indentData.total_quantity || 0);
        result.totalWeight += Number(indentData.total_weight || 0);
        result.totalVolume += convertCftForDisplay(Number(indentData.total_volume || 0), getters.isVolumeInCBM);
        result.hasSelection = true;
      }
    });
    result.totalWeight = Number(result.totalWeight.toFixed(3));
    result.totalVolume = Number(result.totalVolume.toFixed(3));
    result.totalQuantity = Number(result.totalQuantity.toFixed(3));
    return result;
  },
  selectedIndentCount: state => state.selectedIndentIds.length,
  summaryDeliveryNos: state => state.summaryDeliveryNos,
};

export default getters;
